import { Component } from '@angular/core';

@Component({
	selector: 'kng-void',
	template: ' <p>kinetic-angular works!</p> ',
	styles: []
})
export class KineticAngularComponent {}
